import React, { useEffect, useState, useRef } from "react";
import Header from '../../components/header/Header';
import Sidebar from '../../components/sidebar/Sidebar';
import { useNavigate } from "react-router-dom";
import { notificationsListing, deleteNotification } from "../../api/apiHandler";
import { showMessage, showErrorMessage, convertUTCToLocal } from "../common/Utils";
import $ from 'jquery';
import "parsleyjs/src/parsley.css";
import "parsleyjs";
import 'select2';
import 'select2/dist/css/select2.min.css';
import DataTable from "react-data-table-component";
import Swal from "sweetalert2";

export function Notifications() {

    const customStyles = {
        header: {
            style: {
                position: "sticky",
                top: 0,
                zIndex: 2,
                backgroundColor: "#f5f5f5", // Customize as needed
            },
        },
        headCells: {
            style: {
                backgroundColor: '#B6A878',
                color: '#000000',
                fontWeight: 'bold',
                fontSize: '14px',
                textAlign: 'center',
                padding: '10px',
            },
        },
        cells: {
            style: {
                padding: '8px',
                textAlign: 'center',
                borderBottom: '1px solid #e0e0e0',
            },
        },
    };

    let navigate = useNavigate();
    const auth = localStorage.getItem('token');
    const timezone = localStorage.getItem('timezone');
    
    // Redirect to login if not logged in
    if (!auth) {
        navigate('/login');
    }

    const [data, setData] = useState([]);
    const [totalRows, setTotalRows] = useState(0);
    const [loading, setLoading] = useState(false);
    const [search, setSearch] = useState("");
    const [pagination, setPagination] = useState({ page: 1, perPage: 50 });
    const [sortField, setSortField] = useState("id");
    const [sortOrder, setSortOrder] = useState("DESC");

    // Fetch data from server
    const fetchData = async () => {
        setLoading(true);
        try {
            
            const faqReq = {
                page: pagination.page,
                per_page: pagination.perPage,
                search,
                sort: sortField,
                order: sortOrder,
            }
            console.log("REQUEST : ", faqReq);
            const response = await notificationsListing(faqReq);
            if (parseInt(response.code) === 1) {
                setData(response.data.items);
                setTotalRows(response.data.totalcount);
            } else {
                showErrorMessage(response.message);
            }
        } catch (error) {
            console.log("error : ", error);
            showErrorMessage("Something went wrong loading notifications, please try again later");
        }
        setLoading(false);
    };

    useEffect(() => {
        fetchData();
    }, [pagination, search, sortField, sortOrder]);
    
    // Handle pagination
    const handlePageChange = (page) => {
        setPagination((prev) => ({ ...prev, page }));
    };
    
    const handlePerRowsChange = (perPage) => {
        setPagination({ page: 1, perPage });
    };
    
      // Handle sorting
    const handleSort = (column, sortDirection) => {
        setSortField(column.sortableField); // Field to sort by
        setSortOrder(sortDirection.toUpperCase()); // ASC or DESC
    };

    const showDeleteConfirmation = async (notification_id) => {
        try {
            // Show confirmation dialog
            const result = await Swal.fire({
                title: "",
                text: "Are you sure you want to delete this notification?",
                imageUrl: process.env.PUBLIC_URL + '/logo.png',
                imageSize: '80x80',
                showCancelButton: true,
                confirmButtonColor: "#B6A878",
                cancelButtonColor: "#d33",
                confirmButtonText: "Confirm",
            });
            
            if (result.isConfirmed) {

                const updUsers = {
                    is_deleted: true,
                    notification_id: notification_id
                }

                console.log("REQUEST : ", updUsers);
                const response = await deleteNotification(updUsers);
                if (parseInt(response.code) === 1) {
                    showMessage(response.message);
                    fetchData();
                } else {
                    showErrorMessage(response.message);
                }
            }
        } catch (error) {
            showErrorMessage("An unexpected error occurred deleting record!");
        }
    };

    return (
        <>
            <Header />
            <Sidebar />
            <section className="content">
                <div className="block-header">
                    <div className="row">
                        <div className="col-lg-7 col-md-6 col-sm-12">
                            <h2>Notifications</h2>
                        </div>
                        <div className="col-lg-5 col-md-6 col-sm-12">
                            <ul className="breadcrumb float-md-right">
                                <li className="breadcrumb-item">
                                    <a href="/authpanel/dashboard">
                                    <i className="zmdi zmdi-home" />
                                        Dashboard
                                    </a>
                                </li>
                                <li className="breadcrumb-item active">Notifications</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12 col-lg-12 col-xl-12">
                            <div className="card">
                                <div className="body">
                                    <div className="table-responsive">
                                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                            <div>
                                                <a href="/authpanel/notifications/add" className="btn btn-raised btn-primary waves-effect mb-3 mr-3">
                                                    <i className="zmdi zmdi-plus" style={{ color: '#D7C9A1' }} /> Add
                                                </a>
                                            </div>
                                            <div style={{ position: "relative", maxWidth: "300px" }}>
                                                <input
                                                    type="text"
                                                    placeholder="🔍 Search..."
                                                    value={search}
                                                    onChange={(e) => setSearch(e.target.value)}
                                                    style={{
                                                        width: "100%",
                                                        padding: "10px 15px",
                                                        borderRadius: "25px",
                                                        border: "1px solid #ccc",
                                                        outline: "none",
                                                        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                                                        fontSize: "14px",
                                                    }}
                                                    className="form-control mb-3"
                                                />
                                            </div>
                                        </div>
                                        <div style={{ maxWidth: "100%", overflowX: "auto" }}>
                                            <DataTable
                                                columns={[
                                                    { name: "ID", selector: (row) => row.notification_id, sortable: true, sortableField: "id", width: '5%', wrap: true },
                                                    { name: "CONTENT", selector: (row) => row.content, sortable: false, width: '55%', wrap: true },
                                                    { name: "USER COUNT", selector: (row) => <label className="label label-success">{row.customer_count}</label>, sortable: false, width: '10%', wrap: true },
                                                    { name: "CREATED AT", selector: (row) => convertUTCToLocal(row.created_at, timezone), sortable: true, width: '20%', wrap: true },
                                                    { 
                                                        name: "ACTIONS", 
                                                        selector: (row) => (
                                                            <div>
                                                                <a
                                                                    href="#"
                                                                    onClick={() => showDeleteConfirmation(row.notification_id)}
                                                                    className="btn btn-xs waves-effect waves-float waves-green mr-1"
                                                                    style={{ marginBottom: '1px', border: '1px solid #D7C9A1' }}
                                                                >
                                                                    <i className="zmdi zmdi-delete" style={{ color: '#D7C9A1' }} />
                                                                </a>
                                                            </div>
                                                        ),
                                                        sortable: false,
                                                        width: '10%',
                                                        wrap: true
                                                    },
                                                ]}
                                                data={data || []}
                                                defaultSortField="id"
                                                defaultSortAsc={false}
                                                pagination
                                                paginationServer
                                                paginationTotalRows={totalRows}
                                                paginationRowsPerPageOptions={[10, 20, 50, 100]}
                                                paginationPerPage={50} // Default page size
                                                onChangePage={handlePageChange}
                                                onChangeRowsPerPage={handlePerRowsChange}
                                                onSort={handleSort}
                                                sortServer
                                                persistTableHead
                                                progressPending={loading}
                                                customStyles={customStyles}
                                                noDataComponent={<div style={{ textAlign: "center", padding: "20px", color: "#888" }}>No data found</div>}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}